export const CATEGORIES = [
    'Software Engineer',
    'UX/UI Developer',
    'System Analyst',
    'Data Analyst',
    'Machine Learning Engineer'
];


// WEBPACK FOOTER //
// ./src/components/Resumes/constants.js